/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Azione sul ciclo di vita del bando con precondizione runtime
 */
export enum AzioneStato {

    CONFERMA_GRADUATORIA = 'CONFERMA_GRADUATORIA',

    RIPRISTINA = 'RIPRISTINA',

    DEPUBBLICA = 'DEPUBBLICA',

    CALCOLA_GRADUATORIA = 'CALCOLA_GRADUATORIA'
}

